import { render, staticRenderFns } from "./RegisterV2Component.vue?vue&type=template&id=0df8abaf&"
import script from "./RegisterV2Component.vue?vue&type=script&lang=js&"
export * from "./RegisterV2Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports